import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7657
 *
 * @param {SvgIconProps} props - svg props
 */
export const NotificationIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M2.72705 8.27295C2.72705 5.51152 4.96563 3.27295 7.72705 3.27295H11.4541V5.45459H7.90869C6.25184 5.45459 4.90869 6.79773 4.90869 8.45459V15.5455C4.90869 17.2024 6.25184 18.5455 7.90869 18.5455H16.0905C17.7474 18.5455 19.0905 17.2024 19.0905 15.5455V13.0911H21.2723V8.22993C21.2724 8.24426 21.2725 8.2586 21.2725 8.27295V15.7275C21.2725 18.4889 19.0339 20.7275 16.2725 20.7275H7.72705C4.96563 20.7275 2.72705 18.4889 2.72705 15.7275V8.27295Z' fill={color}/>
            <ellipse cx='18.2724' cy='6.27286' rx='4.90909' ry='4.90909' fill={color}/>
        </SvgIcon>
    )
}

export default NotificationIcon
